module.exports = __webpack_public_path__ + "img/interface OneB Clock-server_2.ec6297ef.jpg";